import Link from 'next/link'
import { Money } from '@shopify/hydrogen-react'
import { ResponsiveImage } from '../ResponsiveImage'

export const SearchResult = ({ onClick, handle, title, src, priceRange }) => {
  return (
    <Link
      scroll={false}
      href={`/products/${handle}`}
      onClick={onClick}
      className="flex items-center justify-between rounded-8 bg-white p-10 text-12 transition-all duration-300 hover:shadow-sm"
    >
      <div className="flex flex-col gap-8">
        <div>{title}</div>
        <Money data={priceRange.maxVariantPrice} withoutTrailingZeros />
      </div>
      <div>
        <div className="relative h-[68px] w-[46px] overflow-hidden rounded-6">
          <ResponsiveImage src={src} alt={`Product photo for ${title}`} />
        </div>
      </div>
    </Link>
  )
}
